import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import { Link } from '@calendly/ui/components/link';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useState, useEffect, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { domainControlSettingSelector, ORG_MEMBERSHIP_ACCESS_OWNER_TYPE } from 'features/organization_settings';
const wrapperRemoveCss = "w155p6k";
const wrapperCss = "w1a35wqm";
const Wrapper = forwardRef((props, ref) => {
  const {
    remove,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperRemoveCss]: remove
  }, props.className)} />;
});
const DomainControlLink = ({
  children
}) => <Link href="/app/organization/settings/domains">{children}</Link>;

// i18n-tasks-use t('publisher.organization.members.domain_control_remove_warning')
// i18n-tasks-use t('publisher.organization.members.domain_control_change_role_warning')
export const DomainControlNotice = ({
  memberships,
  remove = false
}) => {
  const [membership, setMembership] = useState(undefined);
  const domainControlSettings = useSelector(domainControlSettingSelector);
  useEffect(() => {
    if (domainControlSettings.hasExistingSetting && domainControlSettings.accessOwnerType === ORG_MEMBERSHIP_ACCESS_OWNER_TYPE) {
      const domainControlOwner = memberships.find(member => member.uuid === domainControlSettings.accessOwnerValue);
      setMembership(domainControlOwner);
    } else {
      setMembership(undefined);
    }
  }, [memberships, domainControlSettings]);
  if (membership == null) {
    return null;
  }
  return <Wrapper remove={remove}>
      <ContextualBanner>
        <p>
          {HtmlParser(I18n.t(`publisher.organization.members.${remove ? 'domain_control_remove_warning' : 'domain_control_change_role_warning'}`, {
          name: membership.name
        }), {
          DomainControlLink
        })}
        </p>
      </ContextualBanner>
    </Wrapper>;
};
DomainControlNotice.propTypes = {
  memberships: PropTypes.arrayOf(PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })),
  remove: PropTypes.bool
};

require("./domain_control_notice.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./domain_control_notice.js");